/**
 * Checks if the user is in an Electron environment
 *
 * @returns true if the user is in an Electron environment, false otherwise
 */
export const isElectron = () => typeof window !== 'undefined' && 'electron' in window;
